import { Form, Input, ModalProps, FormProps, Modal, Spin, Row, Col, Select, Divider, useSelect, Space, Button, Typography } from '@pankod/refine-antd'
import { CrudFilter, useGetIdentity, useList, useTable, useCreateMany } from '@pankod/refine-core'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs, { Dayjs } from 'dayjs'
import {
  IGrade,
  ISubject,
  ITopic,
  IBloomLevel,
  ICentaStandard,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  ITeacherLevel,
  IReportTheme,
  IUser,
  ITheme,
  ISubTheme,
  IAspect,
  IQuestionStatus,
  INotification,
  IWorkRequestApprover,
  IWorkRequestReviewer,
  ITNTaxonomy,
  ICompetency,
  IStrand,
  IWorkRequestGrades,
} from 'interfaces'

import sendEmail from 'sendmail'
import { useEffect, useState } from 'react'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'

import { CreateWorkRequestReviewers, getLastCreatedWorkRequest, createUserHistory } from 'gql/mutations'

import { DatePicker } from 'antd'
// Save draft btn style

import 'styles/custom.css'
import { useUserContext } from 'context/user'
import { useGrades, useSubjects, useBloomsLevel, useDifficultyLevels, useCompetency, useReportTheme } from 'utility/masterData'
import { getReportThemeDataByTopicId } from 'gql/query'
type CreateWorkRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  refreshData?: any
  success: any
}
const { Text } = Typography

export const CreateWorkRequest: React.FC<CreateWorkRequestProps> = ({ modalProps, formProps, close, success, refreshData }) => {
  const { data: user } = useGetIdentity()
  const [requestType, setRequestType] = useState('Q')
  const { userRole, qapproverList, qcreatorList, qreviewerList, vcreatorList } = useUserContext()
  const [subthemeId, setSubthemeId] = useState('')

  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([])
  const [reviewers, setReviewers] = useState<object[]>([])
  const [saveAsDraft, setSaveDraft] = useState(false)
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [totalVariantCount, setTotalVariantCount] = useState<number[]>([])
  const [questionCount, setQuestionCount] = useState(5)
  const [taxonomyfilter, setTaxonomyFilter] = useState([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [allReviewers, setAllReviewers] = useState<object[]>([])
  const [showApprover, setShowApprover] = useState<boolean>(false)
  const [selectedReviewersList, setSelectedReviewerList] = useState<string[]>([])
  const [selectedReviewerIds, setSelectedReviewerIDS] = useState<string[]>([])
  const [questionQueryEnabled, setQuestionQueryEnabled] = useState(false)
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)
  const [themeQueryEnabled, setThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const gradeSelectProps = useGrades(modalProps?.visible)
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  const subjectSelectProps = useSubjects(modalProps?.visible)
  const competencySelectProps = useCompetency(modalProps?.visible)
  // const [reportThemeData, setReportThemeData] = useState([] as any[])
  var notification_arr: object[] = []
  var mail_arr: object[] = []
  const { mutate } = useCreateMany<INotification>()
  const { mutate: createReviewers } = useCreateMany<IWorkRequestReviewer>()
  const { mutate: createApprovers } = useCreateMany<IWorkRequestApprover>()
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const [validation, setValidation] = useState({
    question_type_id: true,
    subject_id: true,
    creator_id: true,
  })
  const { filters, setFilters, tableQueryResult, sorter } = useTable<ITopic>({
    resource: 'topics',
    queryOptions: { enabled: TopicQueryEnabled && modalProps?.visible },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialPageSize: 5000,
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    queryOptions: { enabled: themeQueryEnabled && modalProps?.visible },
    resource: 'themes',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    queryOptions: { enabled: subThemeQueryEnabled && modalProps?.visible },
    resource: 'sub_themes',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'theme_id'] },
  })
  const {
    filters: questionFilter,
    setFilters: setQuestionFilters,
    tableQueryResult: questionResult,
  } = useTable<IQuestion>({
    resource: 'questions',
    queryOptions: {
      enabled: questionQueryEnabled && modalProps?.visible,
    },
    metaData: { fields: ['id', 'title'] },
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'active',
        operator: 'eq',
        value: 'true',
      },
    ],
  })
  useEffect(() => {
    setShowApprover(false)
    setAllReviewers([])
    setSelectedReviewerIDS([])
    setDisableSaveBtn(false)
  }, [])

  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs().add(-1, 'day')
  }
  // const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
  //   queryOptions:{staleTime:Infinity,enabled:modalProps?.visible && reportThemeQueryEnabled},
  //   // defaultValueQueryOptions:{enabled:},
  //   resource: 'report_themes',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   filters: subjectFilter,
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const reportThemeSelectProps = useReportTheme(modalProps?.visible, subjectFilter)

  const handleRequestType = (value: any) => {
    setRequestType(value)
    formProps?.form?.setFieldsValue({
      creator_id: null,
    })
  }
  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    questionFilter.pop()
    // add for removing current filter
    themeFilters.pop()
    // setReportThemeData([])

    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
      report_theme_id: null,
    })
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
    // added for geting theme based on subject
    setThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])

    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    setQuestionQueryEnabled(true)
    setReportThemeQueryEnabled(true)
    setThemeQueryEnabled(true)
  }
  // removing report theme change for now
  // const handleReportThemeChange = (value: { value: any }) => {
  //   themeFilters.pop()
  //   formProps?.form?.setFieldsValue({
  //     sub_theme_id: null,
  //     topic_id: null,
  //     theme_id: null,
  //     // questionResult: null,
  //   })

  //   setThemeFilters([
  //     {
  //       field: 'report_theme_id',
  //       operator: 'eq',
  //       value: value,
  //     },
  //   ])
  //   setThemeQueryEnabled(true)
  // }

  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setSubThemeQueryEnabled(true)
  }
  const handleSubThemeChange = (value: { value: any }) => {
    filters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setTopicQueryEnabled(true)
  }

  const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
    queryOptions: { enabled: modalProps?.visible },
    resource: 'tn_taxonomys',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(taxonomyfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: strandSelectProps } = useSelect<IStrand>({
    queryOptions: { enabled: modalProps?.visible },
    resource: 'strands',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(strandfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    // let arr: any[] = [...strandfilter]
    // let data: any = {
    //   field: 'taxonomy_id',
    //   operator: 'eq',
    //   value: value,
    // }
    // arr.push(data)
    // setStrandFilter(arr)
    const updatedFilters = strandfilter.filter(filter => filter.field !== 'taxonomy_id')
    updatedFilters.push({
      field: 'taxonomy_id',
      operator: 'eq',
      value: value,
    })
    setStrandFilter(updatedFilters)
  }

  const handleTeacherLevelChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'teacher_level_id',
      operator: 'eq',
      value: value,
    }

    arr.push(data)

    setStrandFilter(arr)
  }

  const changeApprover = (value: string[], rid: string) => {
    allReviewers.map((item: any, index: any) => {
      if (item?.reviewer?.id === rid) {
        let app_data: object[] = []
        let app_ids: string[] = []
        if (app_ids === undefined) {
          app_ids = []
        }
        for (let i = 0; i < value.length; i++) {
          app_data.push(qapproverList?.filter((list: any) => list?.id === value[i])[0])

          app_ids.push(qapproverList?.filter((list: any) => list?.id === value[i])[0]?.id)
          app_data = app_data.filter((thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.id === thing.id))
          app_ids = app_ids.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index
          })
        }
        item['approver_ids'] = app_data
        item['ap_ids'] = app_ids
      }
    })
  }
  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)
    let approverData: object[] = []
    let allApproverData: object[] = []
    //for removing undefined if reviewers or grades are not selected
    values.reviewer_ids = !Array.isArray(values.reviewer_ids) ? [] : values.reviewer_ids
    values.grade_ids = !Array.isArray(values.grade_ids) ? [] : values.grade_ids
    allReviewers.map((item: any, i: any) => {
      delete values['approver_ids_' + i]
      delete values['reviwer_id_selected_' + i]

      if (selectedReviewerIds.includes(item?.reviewer?.id)) {
        item?.ap_ids.map((ids: any) => {
          allApproverData.push(ids)
        })

        approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
      }
    })
    allApproverData = allApproverData.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })

    if (JSON.stringify(values?.reviewer_ids) !== '{}' && values?.reviewer_ids !== null && values?.reviewer_ids !== undefined) {
      values?.reviewer_ids.map((item: any) => {
        notification_arr.push({
          description: `You are assigned as reviewer for work request ${values?.name} `,
          sender: user?.id,
          recepient: item,
          source_name: 'work_requests',
          title: 'New Task',
          recepient_user_role: 'qreviewer',
        })
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === item)[0]
        mail_arr.push({
          subject: 'Work Request Created and assigned to you',
          to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
          htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Questions to review will assign shortly.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        })
      })
    }
    if (approverData.length > 0) {
      approverData?.map((item: any) => {
        item?.approver_ids.map((approver: any) => {
          notification_arr.push({
            description: `You are assigned as approver for work request ${values?.name}`,
            sender: user?.id,
            recepient: approver,
            source_name: 'work_requests',
            title: 'New Task',
            recepient_user_role: 'qapprover',
          })
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approver)[0]
          mail_arr.push({
            subject: 'Work Request Created and assigned to you',
            to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
            htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Question to approve will assign shortly.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          })
        })
      })
    }
    if (values?.creator_id !== '' && values?.creator_id !== null && values?.creator_id !== undefined) {
      notification_arr.push({
        description: 'Work Request created and assigned to you',
        sender: user?.id,
        recepient: values?.creator_id,
        source_name: 'work_requests',
        title: 'New Task',
        recepient_user_role: requestType === 'Q' ? 'qcreator' : 'variantcreator',
      })
      let creatorDetails = []
      if (requestType === 'Q') {
        creatorDetails = qcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }
      if (requestType === 'V') {
        creatorDetails = vcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }

      mail_arr.push({
        subject: 'Work Request Created and assigned to you',
        to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
        htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. You have to create ${values?.count} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
    }

    let count = questionCount
    if (requestType === 'V') {
      count = 0
      values?.variant_options?.map((item: any) => {
        count = count + parseInt(item?.variant_count)
      })
    }
    console.log(values, 'values are this')
    // if topic Id is present then finding RT
    if (values?.topic_id) {
      const topicId = values?.topic_id
      const reportThemeDetails: any = await getReportThemeDataByTopicId(topicId)
      //if report theme present then
      if (reportThemeDetails?.report_themes[0]?.id) {
        const reportThemeId = reportThemeDetails.report_themes[0].id
        values.report_theme_id = reportThemeId
      }
    }
    if (saveAsDraft === true) {
      setSaveDraft(false)
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Draft',
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
          subject_id: values?.subject_id !== '' ? values?.subject_id : null,
          question_type_id: values?.question_type_id !== '' ? values?.question_type_id : null,
          creator_id: values?.creator_id !== '' ? values?.creator_id : null,
        })
      )
    } else {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Open',
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
        })
      )
    }
  }
  const reviewerChange = (value: string[]) => {
    let arr: object[] = []
    let ids: string[] = []
    let all_data = [...allReviewers]
    if (value.length > 0) {
      for (let i = 0; i < value?.length; i++) {
        const result = qreviewerList?.filter((item: any) => item?.id === value[i])[0]
        console.log({ result })
        arr.push(result)
        ids.push(value[i])
        all_data.push({ reviewer: result, approver_ids: [], ap_ids: [] })
      }
      ids = ids.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })

      all_data = all_data.filter(
        (elem: any, index: any, self: any) =>
          self.findIndex((t: any) => {
            return t?.reviewer?.id === elem?.reviewer?.id
          }) === index
      )
      console.log({ qreviewerList })
      setAllReviewers(all_data)
      setSelectedReviewerIDS(ids)
      setReviewers(arr)
    } else {
      setAllReviewers([])
      setSelectedReviewerIDS([])
      setReviewers([])
    }
  }

  const addApprover = () => {
    setShowApprover(true)
  }

  const onSearch = (value: string) => {
    console.log('value-----', value)
  }
  return (
    <Modal {...modalProps} title="Create Work Request" okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              let work_request_id = response?.data?.id
              //  let reviwer_arr: object[] = []
              //     let approver_arr: object[] = []
              //     if (values?.reviewer_ids !== null && values?.reviewer_ids !== undefined && JSON.stringify(values?.reviewer_ids) !== '{}') {
              //       values?.reviewer_ids?.map((item: any) => {
              //         reviwer_arr.push({ user_id: item, work_request_id: work_request_id })
              //       })

              //       createReviewers({
              //         resource: 'work_request_reviewers',
              //         values: reviwer_arr,
              //       })
              //     }
              // let approverData: object[] = []

              // allReviewers.map((item: any, i: any) => {
              //   delete values['approver_ids_' + i]
              //   if (selectedReviewerIds.includes(item?.reviewer?.id))
              //     approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
              // })
              // if (approverData.length > 0) {
              //   approverData?.map((item: any) => {
              //     item?.approver_ids.map((approver: any) => {
              //       approver_arr.push({ approver_id: approver, work_request_id: work_request_id, reviewer_id: item?.reviwer_id_selected })
              //     })
              //   })
              //   createApprovers({
              //     resource: 'work_request_approvers',
              //     values: approver_arr,
              //   })
              // }
              refreshData()
              if (!saveAsDraft) {
                sendEmail(mail_arr)
                notification_arr.map((item: any) => {
                  item['redirect_id'] = work_request_id
                  item['redirect_component'] = 'show'
                  // item.push({
                  //   redirect_id: work_request_id,
                  //   redirect_component: 'show',
                  // })
                })
                mutate({
                  resource: 'notifications',
                  values: notification_arr,
                })
              }
              let grade_array: object[] = []
              if (values?.grade_ids?.length > 0) {
                values?.grade_ids?.map((item: any) => {
                  grade_array.push({
                    grade_id: item,
                    work_request_id: work_request_id,
                  })
                })

                createGrades({
                  resource: 'work_request_grades',
                  values: grade_array,
                })
              }
              // createUserHistory('work_requests', 'create', work_request_id, user?.id, userRole)
              setDisableSaveBtn(false)
              setShowApprover(false)
              setAllReviewers([])
              setSelectedReviewerIDS([])
              setDisableSaveBtn(false)
              // createUserHistory('blooms_levels', 'edit', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Request Type" name="request_type" initialValue={'Q'} rules={[{ required: true }]}>
              <Select
                allowClear
                onChange={handleRequestType}
                options={[
                  { label: 'Question', value: 'Q' },
                  { label: 'Variant', value: 'V' },
                  { label: 'Parent Child', value: 'PC' },
                ]}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
              <Select {...workrequestStatusSelectProps} />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Question Type" name="question_type_id" rules={[{ required: false }]}>
              <Select {...questionTypeSelectProps} allowClear />
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: false }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids" rules={[{ required: false }]}>
              <Select {...gradeSelectProps} mode="multiple" allowClear showSearch={false} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: validation?.subject_id }]}>
              <Select {...subjectSelectProps} showSearch onChange={handleSubjectChange} allowClear />
            </Form.Item>
          </Col>

          {/* commenting report theme change code for now */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: false }]}>
              <Select
                // onSearch={onSearch}
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                {...reportThemeSelectProps}
                disabled={
                  formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false
                }
                onChange={handleReportThemeChange}
                allowClear
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} lg={8}>
            <Form.Item label="Theme" name="theme_id" rules={[{ required: false }]}>
              <Select
                onChange={handleThemeChange}
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear
                disabled={
                  // formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') == null
                  //   ? true
                  //   : false
                  formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false
                }
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: false }]}>
              <Select
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={handleSubThemeChange}
                allowClear
                disabled={
                  formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                }
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Topic" name="topic_id" rules={[{ required: false }]}>
              {/* <TopicSelector /> */}
              {/* <Select {...topicSelectProps} /> */}
              <Select
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear
                disabled={
                  formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                    ? true
                    : false
                }
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {requestType === 'Q' || requestType === 'PC' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Number of questions (Fill in with either 9 or 25)"
                name="count"
                initialValue={questionCount}
                rules={[{ required: true }]}
              >
                <Input onChange={e => setQuestionCount(parseInt(e.target.value))} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row gutter={[16, 0]}>
          {requestType === 'Q' || requestType === 'PC' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the creator's name" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('qcreator', value)}
                  // filterOption={false}
                >
                  {qcreatorList.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          ) : (
            <Col xs={24} lg={8}>
              <Form.Item label="Variant Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('variantcreator', value)}
                  // filterOption={false}
                >
                  {vcreatorList.length > 0 &&
                    vcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          )}

          <Col xs={24} lg={8}>
            <Form.Item label="Choose the reviewer's name (if known)" name="reviewer_ids" rules={[{ required: false }]}>
              <Select
                mode="multiple"
                onChange={reviewerChange}
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // onSearch={value => searchUser('qreviewer', value)}
                // filterOption={false}
              >
                {qreviewerList.length > 0 &&
                  qreviewerList?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            {showApprover
              ? allReviewers.length > 0 &&
                allReviewers.map((elem: any, i: any) => (
                  <Row
                    key={i}
                    gutter={[16, 0]}
                    style={{ display: selectedReviewerIds.length > 0 && !selectedReviewerIds.includes(elem?.reviewer?.id) ? 'none' : 'flex' }}
                  >
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Reviewer"
                        name={'reviwer_id_selected_' + i}
                        rules={[
                          {
                            required: false,
                            message: 'Select a Reviewer',
                          },
                        ]}
                      >
                        <Input placeholder={elem?.reviewer?.displayName} defaultValue={elem?.reviewer?.displayName} readOnly />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                      <Form.Item
                        label="Choose the approver's name (if known)"
                        name={'approver_ids_' + i}
                        rules={[{ required: false, message: 'Select an Approver' }]}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          showSearch
                          filterOption={(input: any, option: any) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          // onSearch={value => searchUser('qapprover', value)}
                          // filterOption={false}
                          defaultValue={elem?.ap_ids}
                          onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                        >
                          {qapproverList.length > 0 &&
                            qapproverList?.map(item => (
                              <option key={item?.id} value={item?.id}>
                                {item?.displayName}
                              </option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ))
              : null}
            <Form.Item>
              <Button type="dashed" onClick={() => addApprover()} block icon={<PlusOutlined />}>
                Add Approver
              </Button>
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select allowClear showSearch onChange={handleCompetencyChange} {...competencySelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="taxonomy_id" rules={[{ required: false }]}>
              <Select
                allowClear
                showSearch
                disabled={
                  formProps?.form?.getFieldValue('competency_id') === undefined || formProps?.form?.getFieldValue('competency_id') == null
                    ? true
                    : false
                }
                onChange={handleTaxonomyChange}
                {...tntaxonomySelectProps}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Standard" name="strand_id" rules={[{ required: false }]}>
              <Select
                allowClear
                showSearch
                disabled={
                  formProps?.form?.getFieldValue('taxonomy_id') === undefined || formProps?.form?.getFieldValue('taxonomy_id') == null ? true : false
                }
                {...strandSelectProps}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Teacher Level" name="teacher_level_id" rules={[{ required: false }]}>
              <Select onChange={handleTeacherLevelChange} {...teacherlevelSelectProps} />
            </Form.Item>
          </Col> */}

          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select {...bloomlevelSelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select {...difficultylevelSelectProps} allowClear />
            </Form.Item>
          </Col>

          {requestType === 'V' ? (
            <>
              <Col xs={24} lg={24}>
                <Divider orientation="left" orientationMargin="0" className="primary">
                  Add Variants
                </Divider>
              </Col>
              <Col xs={24} lg={24}>
                <Form.List name="variant_options">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={[16, 0]}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              {...restField}
                              label="Variant Question"
                              name={[name, 'question_id']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Select a Question',
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input: any, option: any) =>
                                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {questionResult?.data?.data?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={8}>
                            <Form.Item
                              {...restField}
                              label="Variant Count"
                              name={[name, 'variant_count']}
                              rules={[{ required: true, message: 'Missing Count' }]}
                            >
                              <Input placeholder="Variant Count" type="small" />
                            </Form.Item>
                          </Col>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Row>
                        // </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Variants
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </>
          ) : null}

          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Divider />
        <Row gutter={[16, 0]} justify="end" align="top">
          <Spin spinning={disableSaveBtn}></Spin>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Submit
              </Button>
              <Button
                className="save-draft-btn"
                htmlType="submit"
                onClick={() => {
                  setValidation({ question_type_id: false, subject_id: false, creator_id: false })
                  setSaveDraft(true)
                }}
              >
                Save Draft
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
